var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConflict(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEF2E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1172_17431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8754 9.51746C16.7889 9.36099 16.6621 9.23056 16.5082 9.13972C16.3543 9.04888 16.1788 9.00098 16.0001 9.00098C15.8213 9.00098 15.6458 9.04888 15.4919 9.13972C15.3379 9.23056 15.2111 9.36099 15.1247 9.51746L8.62472 21.5174C8.54066 21.6697 8.49776 21.8412 8.50026 22.0151C8.50275 22.189 8.55054 22.3592 8.63893 22.509C8.72731 22.6588 8.85322 22.7829 9.00424 22.8692C9.15525 22.9554 9.32614 23.0008 9.50005 23.0008H22.5001C22.6739 23.0008 22.8449 22.9554 22.9959 22.8692C23.1469 22.7829 23.2728 22.6588 23.3612 22.509C23.4495 22.3592 23.4973 22.189 23.4999 22.0151C23.5023 21.8412 23.4594 21.6697 23.3754 21.5174L16.8754 9.51746Z",
    stroke: "#C4870E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18V13.5",
    stroke: "#C4870E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5C15.8619 20.5 15.75 20.3881 15.75 20.25C15.75 20.1119 15.8619 20 16 20",
    stroke: "#C4870E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5C16.1381 20.5 16.25 20.3881 16.25 20.25C16.25 20.1119 16.1381 20 16 20",
    stroke: "#C4870E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1172_17431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConflict);
export default __webpack_public_path__ + "static/media/Conflict.94ad5220ed9bb2dc1e00fcf9577f5188.svg";
export { ForwardRef as ReactComponent };